<template>
<div class="slideover-ctnr" ref="slideover" @click="closeSlideover()">
    <div class="slideover" ref="slideover" @click="$event.stopPropagation()">
        <div class="slideover-header">
            <h2 class="title">
                <span class="title-type">{{entry.type}}</span>
                <span>{{entry.title}}<span class="at-symbol">&nbsp;@&nbsp;</span>{{entry.company}}</span>
            </h2>
            <a v-if="entry.link != ''" :href="entry.link" target="_blank"><img :src="require('./../assets/icon_link.svg')" alt=""></a>
            <!-- <button @click="viewCaseStudy = !viewCaseStudy">View Case Study</button> -->
            <button class="arrow-close" ref="closeModalButton" @click="closeSlideover()"><img src="./../assets/icon_close_dark.svg" alt=""></button>
        </div>
        <div class="slideover-scrollable-content custom-scroll">
            <div class="casestudy-ctnr" v-if="entry.caseStudy">
                <h2 class="title">context</h2>
                <p class="summary" v-for="(context, index) in entry.caseStudy.context" :key="index">{{context}}</p>
                <ul><li class="summary" v-for="(item, index) in entry.caseStudy.contextList" :key="index">{{item}}</li></ul>
            </div>
            <h2 class="title" v-if="entry.id == 0 || entry.id == 1">final product</h2>
            <div class="image-ctnr" :class="{'shadow': entry.imageBorders}" v-for="(imageInfo, index) in entry.imageInfos" :key="index">
                <img 
                    ref="images"
                    :src="require('./../../public/images/' + entry.id + '_' + index + '.svg')">
                <div role="button" class="modal modal-point" tabindex="0"
                    ref="modalPoints" :imageIndex="index"
                    v-for="(point, i) in entry.imageInfos[index].points" :key="i" 
                    @click="toggleModalPoint(point.id)"
                    :style="{animationDelay: 1 + (point.id / 10) + 's'}">
                    <button aria-label="close info modal" class="modal-close" :tabindex="hasExpanded(point.id) ? 0 : -1">
                        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L4.5 4.5M8 8L4.5 4.5M4.5 4.5L8 1L1 8" stroke="white" stroke-width="2"/>
                        </svg>
                    </button>
                    <p class="icon-question"><img :src="require('./../assets/icon_question.svg')" alt=""></p>
                    <p class="modal-text">{{point.text}}</p>
                </div>
            </div>
            <span v-if="entry.caseStudy && entry.caseStudy.contextItems[0]">
                <div class="casestudy-ctnr">
                    <h2 class="title">{{entry.caseStudy.contextItems[0].title}}</h2>
                    <p style="margin-bottom: 15px;" v-for="(p, index) in entry.caseStudy.contextItems[0].summary" :key="index" class="summary">{{p}}</p>
                    <ul><li class="summary" v-for="(solution, index) in entry.caseStudy.contextItems[0].solutions" :key="index">{{solution}}</li></ul>
                </div>
                <div class="image-ctnr" v-if="entry.id == 1">
                    <img :src="require('./../../public/images/1_a.svg')">
                </div>
                <div class="image-ctnr" v-if="entry.id == -2">
                    <img :src="require('./../../public/images/-2_1.svg')">
                </div>
            </span>
            <span v-if="entry.caseStudy && entry.caseStudy.contextItems[1]">
                <div class="casestudy-ctnr">
                    <h2 class="title">{{entry.caseStudy.contextItems[1].title}}</h2>
                    <p style="margin-bottom: 15px;" v-for="(p, index) in entry.caseStudy.contextItems[1].summary" :key="index" class="summary">{{p}}</p>
                    <ul><li class="summary" v-for="(solution, index) in entry.caseStudy.contextItems[1].solutions" :key="index">{{solution}}</li></ul>
                </div>
                <div class="image-ctnr" v-if="entry.id == -1">
                    <img :src="require('./../../public/images/-1_a.svg')">
                </div>
                <div class="image-ctnr" v-if="entry.id == 1">
                    <img :src="require('./../../public/images/1_b.svg')">
                </div>
                <div class="image-ctnr" v-if="entry.id == -2">
                    <img :src="require('./../../public/images/-2_2.svg')">
                </div>
            </span>
            <span v-if="entry.caseStudy && entry.caseStudy.contextItems[2]">
                <div class="casestudy-ctnr" style="margin-bottom: 70px;">
                    <h2 class="title">{{entry.caseStudy.contextItems[2].title}}</h2>
                    <p style="margin-bottom: 15px;" v-for="(p, index) in entry.caseStudy.contextItems[2].summary" :key="index" class="summary">{{p}}</p>
                    <ul><li class="summary" v-for="(solution, index) in entry.caseStudy.contextItems[2].solutions" :key="index">{{solution}}</li></ul>
                </div>
                <div class="image-ctnr" v-if="entry.id == -2">
                    <img :src="require('./../../public/images/-2_3.svg')">
                </div>
            </span>
        </div>
        
    </div>
</div>    
</template>

<script>
export default {
    data() {
        return {
            tagTitles: ['Ideate', 'Wireframe', 'Design', 'Develop', 'Audit'],
            viewCaseStudy: false
        }
    },
    props: {
        visible: {
            default: false
        },
        entry: {
            type: Object,
            default: () => ({
                id: 0,
                title: 'title',
                company: 'company',
                summary: 'summary',
                users: ['user'],
                tags: [true, true, true, true, true],
                hideArrow: false,
                imageInfos: [
                    {points: 
                        [
                            {id: 0, x: 28, y: 1.5, text: 'modal point text'}
                        ]
                    }
                ]
            })
        }
    },
    mounted() {
        setTimeout(()=> {
            this.setModalPoints();
            this.$refs.slideover.classList.add('visible');
        }, 2000);
    },
    created() {
        window.addEventListener('resize', this.setModalPoints);
        // this.setModalPoints();
    },
    destroyed() {
        window.removeEventListener('resize', this.setModalPoints);
        this.setModalPoints();
    },
    watch: {
        visible() {
            if(this.visible) {
                this.$refs.closeModalButton.focus()
                setTimeout(()=> {
                    this.setModalPoints();
                }, 2000);
            }
        }
    },
    methods: {
        closeSlideover() {
            this.$refs.slideover.classList.remove('visible');
            setTimeout(()=> {
                this.$emit('closeSlideover');
            }, 500);
        },
        getImage(imagePath) {
            return imagePath;
        },
        toggleModalPoint(modalPointID) {
            //consider adding a loop to close all existing modals before opening the one specified
            let mp = this.$refs.modalPoints[modalPointID].classList;
            mp.contains('expanded') ? mp.remove('expanded') : mp.add('expanded');
            this.$refs.modalPoints[modalPointID].getBoundingClientRect().right > (window.innerWidth || document.documentElement.clientWidth) ?
                mp.add('expanded-left') :
                null;
        },
        hasExpanded(modalPointID) {
            setTimeout(()=> {
                return this.$refs.modalPoints[modalPointID].classList.contains('expanded');
            }, 100);
        },
        getModalPointX(percent, index) {
            var width = this.$refs.images[index].clientWidth;
            return Math.floor(width * (percent / 100));
        },
        getModalPointY(percent, index) {
            var height = this.$refs.images[index].clientHeight;
            return Math.floor(height * (percent / 100));
        },
        setModalPoints() {
            //run through all modalPoint refs and set their translations properly.
            let modalPoints = this.$refs.modalPoints;
            let imageInfos = this.entry.imageInfos;
            for(let i=0; i<modalPoints.length; i++) {
                for(let j=0; j<imageInfos.length; j++) {
                    if(modalPoints[i].attributes.imageIndex.nodeValue == j) {
                        //check what modal point has an id that matches the index of the current modalPoints ref
                        for(let k=0; k<modalPoints.length; k++) {
                            if(imageInfos[j].points[k] && imageInfos[j].points[k].id == i) {
                                //on a match, set the modal point's transform.
                                let x = this.getModalPointX(imageInfos[j].points[k].x, j);
                                let y = this.getModalPointY(imageInfos[j].points[k].y, j);
                                this.$refs.modalPoints[i].style.transform = 'translate(' + x + 'px,' + y + 'px)';
                            }
                        }
                    }
                }
            }
            // console.log(this.$refs.modalPoints);
        }
    }
}
</script>

<style scoped lang="scss">
.slideover-ctnr {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    // transform: translateX(-100%);
    opacity: 0;
    z-index: 200;
    transition: all 0.2s ease-in-out;
    background-color: rgba(0,0,0,0.0);
    &.visible {
        // transform: translateX(0%);
        opacity: 1;
        background-color: rgba(0,0,0,0.1);
        backdrop-filter: blur(20px);
        transition: all 0.2s ease-in-out;
        .slideover {
            // box-shadow: 0 0 60px 0 rgba(0,0,0,0.2);
        }
    }
    .slideover {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 90vw;
        max-width: 1300px;
        height: 90vh;
        max-height: 90vh;
        background-color: white;
        left: 0;
        box-shadow: none;
        // transition: all 0.1s ease-in-out;
        border-radius: 4px;
        &::after {
            // content: '';
            position: absolute;
            height: 100%;
            width: 2px;
            right: 0px;
            top: 0;
            background: linear-gradient(180deg, #FFE6BA 0%, #2CFFFA 31.77%, #45B0FE 65.1%, #6D8DFF 100%);
        }
        .slideover-header {
            height: 120px;
            min-height: 120px;
            width: calc(100% - 40px);
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            position: sticky;
            top: 0;
            margin-left: 20px;
            background-color: white;
            z-index: 100;
            border-bottom: 1px solid #eee;
            padding: 0 50px;
            // margin-bottom: 2.5rem;
            .title {
                margin-bottom: 0;
            }
            > a {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 5px;
                margin-top: 2px;
                padding: 6px;
                &:active,
                &:hover, 
                &:focus {
                    outline: 0;
                    background-color: var(--color-border-light);
                }
            }
            .summary {
                margin-bottom: 0;
            }
            .arrow-close {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 50px;
                height: 50px;
                // padding-right: 15px;
                margin-left: auto;
                margin-right: -20px;
                cursor: pointer;
                background-color: transparent;
            }         
        }
        .slideover-scrollable-content {
            overflow-y: scroll;
            overflow-x: hidden;
            width: 100%;
            padding: 2.5rem 70px 0 70px;
        }
        .casestudy-ctnr {
            max-width: 650px;
            >p.summary {
                margin-bottom: 5px;
                &:nth-last-of-type(1) {
                    font-weight: 600;
                }
                &:nth-of-type(1) {
                    font-weight: 500 !important; 
                }
            }
            ul {
                margin: 0;
                margin-bottom: 30px;
                margin-top: 10px;
                padding-left: 21px;
                li.summary {
                    margin-bottom: 10px;
                    position: relative;
                    &::before {
                        content: '';
                        position: absolute;
                        top: 6px;
                        left: -20px;
                        width: 6px;
                        height: 6px;
                        border-radius: 2px;
                        background-color: var(--color-dark);

                    }
                }
            }
        }
        .image-ctnr {
            display: block;
            position: relative;
            width: auto;
            margin-bottom: 40px;
            border-radius: 5px;
            max-width: 1200px;
            &.shadow {
                // border: 5px solid #fff;
                // box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1), 0 0 15px 0 rgba(0,0,0,0.2);
                border: 1px solid #dddddd;
            }
            > img {
                width: 100%;
                height: auto;
                border-radius: 3px;
                display: block;
            }
            .modal-point {
                position: absolute;
                opacity: 1;
                width: 26px;
                height: 26px;
                left: 0;
                top: 0;
                // padding: 5px 7px;
                padding: 0;
                pointer-events: all;
                transition: none;
                box-shadow: none;
                overflow: hidden;
                z-index: 1;
                cursor: pointer;
                animation-name: periodBounce;
                animation-duration: 3s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
                top: 0;
                // border: 2px solid white;
                box-shadow: 2px 2px 0 0 #fff, -2px -2px 0 0 #fff, 2px -2px 0 0 #fff, -2px 2px 0 0 #fff;
                &:hover {
                    animation-play-state: paused;
                    .modal-close svg path {
                        stroke: #FF705C;
                    }
                }
                &:focus {
                    .icon-question {
                        opacity: 1;
                    }
                }
                &.expanded {
                    padding: 15px;
                    animation-play-state: paused;
                    width: 300px;
                    height: auto;
                    z-index: 100;
                    &.expanded-left {
                        left: -300px;
                    }
                    &:focus {
                        outline: 0;
                    }
                    .modal-close {
                        opacity: 1;
                        pointer-events: all;
                    }
                    .icon-question {
                        opacity: 0;
                        height: 0;
                        padding: 0;
                        pointer-events: none;
                        &:hover {
                            opacity: 0;
                        }
                    }
                    p.modal-text {
                        opacity: 1;
                        height: auto;
                    }
                }
                &::before {
                    border-color: transparent;
                    border-right-color: var(--color-dark);
                    right: 100%;
                    top: 6px;
                }
                .modal-close {
                    opacity: 0;
                    pointer-events: none;
                }
                .icon-question {
                    opacity: 1;
                    font-weight: 900;
                    line-height: unset;
                    width: 100%;
                    height: 100%;
                    margin-left: 2px;
                    cursor: pointer;
                    opacity: 0.9;
                    padding: 5px 7px;
                    pointer-events: all;
                    &:hover {
                        opacity: 1;
                    }
                }
                p.modal-text {
                    opacity: 0;
                    height: 0;
                    color: #eee;
                    margin-right: 10px;
                }
            }
        }
    }
}

@media screen and (max-width: 810px) {
    .slideover-ctnr {
        .slideover {
            // width: 100%;
            .slideover-scrollable-content {
                padding: 0 30px;
                padding-top: 1.5rem;
            }
            .image-ctnr {
                margin-bottom: 30px;
            }
            .modal-point.expanded {
                width: 200px !important;
                &.expanded-left {
                    left: -174px !important;
                }
            }
            .slideover-header {
                padding: 0 10px;
                height: 80px;
                min-height: 80px;
                .title {
                    display: flex;
                    // flex-direction: column;
                    // align-items: flex-start;
                    gap: 0.25rem;
                    > span:nth-child(2) {
                        line-height: 13px;
                    }
                }
                .arrow-close {
                    // position:absolute;
                    right:15px;
                }
            }
        }
    }
}

@keyframes periodBounce {
    0% {
        top: 0px;
    }
    48% {
        top: 0px;
    }
    50% {
        top: -3px;
    }
    52% {
        top: -3px;
    }
    58% {
        top: 0px;
    }
    100% {
        top: 0px;
    }
}
</style>